<template>
  <!-- v-if="queryParams.total" - 有数据总条数说明有分页信息，则显示分页组件 -->
  <el-pagination
    v-if="queryParams.total"
    medium
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="queryParams.page"
    :page-sizes="pageSizes"
    :page-size="queryParams.limit"
    :layout="layout"
    :total="queryParams.total" class="el-pagination--standard">
  </el-pagination>
</template>

<script>
  export default {
    name: "index",
    props: {
      queryParams: {
        type: Object
      },
      pageSizes: {
        type: Array,
        default() {
          return [5, 10, 20, 50, 100, 200, 500]
        }
      },
      layout: {
        type: String,
        default: 'total, sizes, prev, pager, next, jumper'
      }
    },
    methods: {
      handleSizeChange(val) {
        this.$emit('pagination', { page: this.queryParams.page, limit: val })
      },
      handleCurrentChange(val) {
        this.$emit('pagination', { page: val, limit: this.queryParams.limit })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pagination/index.vue